import type { CmsApiAccordionBlockData } from '#/modules/cms/api/types/blocks/CmsApiAccordionBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAccordionBlock } from './CmsAccordionBlock';

export const CmsAccordionBlockMapping: CmsBlockMapping<CmsApiAccordionBlockData> =
  {
    invariant: [
      {
        prop: 'sections',
        msg: 'Sections required for accordion',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsAccordionBlock,
  };
